import { render } from "./StoryContextCard.vue.js?vue&type=template&id=38d3ef74!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryContextCard.vue?vue&type=template&id=38d3ef74"
import script from "./StoryContextCard.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryContextCard.vue?vue&type=script&lang=js"
export * from "./StoryContextCard.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryContextCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/StoryContextCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38d3ef74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38d3ef74', __exports__)) {
    api.reload('38d3ef74', __exports__)
  }
  
  module.hot.accept("./StoryContextCard.vue.js?vue&type=template&id=38d3ef74!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./StoryContextCard.vue?vue&type=template&id=38d3ef74", () => {
    api.rerender('38d3ef74', render)
  })

}


export default __exports__